import { CycleItemType } from "src/types/journey.types";
import { useParams, useNavigate } from "react-router-dom";
import { Gift } from "lucide-react";
import Button from "../../Button";
import analytics from "src/helpers/analytics";
import { EVENT_NAMES, SCREEN_NAMES } from "src/helpers/analytics/events";

const ClaimFreeDrug = ({
  nextCycle,
  vivitraCardType,
}: {
  nextCycle: CycleItemType;
  vivitraCardType: string;
}) => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const navigate = useNavigate();

  // GET DRUG NAMES
  const getDrugsNames = () => {
    const visitInfo = nextCycle?.visit_meta_info;
    if (!visitInfo) return [];

    const { primary_drugs = [], secondary_drugs = [] } = visitInfo;

    // Collect only drugs that have is_free === "1" or 1
    const freeDrugs = [
      ...primary_drugs.filter(
        (drug: any) => drug.is_free === "1" || drug.is_free === 1
      ),
      ...secondary_drugs.filter(
        (drug: any) => drug.is_free === "1" || drug.is_free === 1
      ),
    ];

    // Return drug names and costs
    return freeDrugs.map((drug: any) => {
      return {
        drug_label: drug.drug_label,
        cost: drug.cost,
      };
    });
  };

  const handleClaimFreeDrug = () => {
    // Event: CLAIM_FREE_DRUG_CLICKED
    analytics.trackEvent(EVENT_NAMES.CLAIM_FREE_DRUG_CLICKED, {
      screen_name: SCREEN_NAMES.TREATMENT_JOURNEY_SCREEN,
      support_program_key: supportProgramKey,
      card_title: "Claim Free Drug",
      free_drugs: getDrugsNames()
        .map((drug) => `${drug.drug_label} (₹${drug.cost})`)
        .join(", "),
      actual_cost: `₹${getDrugsNames()
        .map((drug) => drug.cost)
        .reduce((acc, curr) => acc + curr, 0)}`,
      ...nextCycle,
    });
    navigate(`/app/${supportProgramKey}/journey-details/claim-details`, {
      state: {
        nextCycle,
      },
    });
  };

  const vivitraCardTitle = () => {
    if (vivitraCardType === "SH") {
      return `Your free drugs are on the way`;
    } else if (vivitraCardType === "RC") {
      return "Your Next Step";
    } else if (vivitraCardType === "EL") {
      return "You are eligible for free drugs";
    } else if (nextCycle?.visit_meta_info?.order_status === "Delivered") {
      return "Your free drugs are delivered";
    }
  };

  const vivitraCardDescription = () => {
    if (vivitraCardType === "SH") {
      return "Your claimed free drugs are on their way to you";
    } else if (vivitraCardType === "SH") {
      return "Your drugs are on its way to delivery";
    } else if (vivitraCardType === "EL") {
      return "Claim your free drugs for your next cycle";
    } else if (vivitraCardType === "RC") {
      return "Your free drugs are ready to be claimed";
    } else if (nextCycle?.visit_meta_info?.order_status === "Delivered") {
      return "Your free drugs are delivered to your address";
    }
  };

  const claimButtonText = () => {
    if (vivitraCardType === "SH") {
      return "Claimed";
    } else {
      return "Claim Now";
    }
  };

  const disabledClaim =
    vivitraCardType === "SH" ||
    nextCycle?.visit_meta_info?.order_status === "Delivered";

  return (
    <div className="w-full bg-[var(--icon-bg-primary)] rounded-lg p-4 border border-[var(--app-primary)]">
      <div className="flex gap-2">
        <div className="w-10 min-w-10 h-10 text-[var(--app-primary)] bg-white rounded-full p-2 flex items-center justify-center">
          <Gift className="w-5 h-5" />
        </div>
        <div className="relative w-full">
          <h3 className="text-black text-base font-bold mb-1">
            {vivitraCardTitle()}
          </h3>
          <p className="text-black text-sm">{vivitraCardDescription()}</p>
          <div className="text-black text-sm capitalize mt-2">
            {`${getDrugsNames()
              // .map((drug) => `${drug.drug_name} (₹${drug.cost})`)
              .map((drug) => `${drug.drug_label}`)
              .join(", ")}`}
          </div>
          <div className="flex items-center justify-between gap-2 mt-2">
            <div className="flex items-center gap-2">
              <h4 className="text-black text-base font-bold">Free </h4>
              {/* <span className="text-black text-sm font-medium line-through">
                {`₹${getDrugsNames()
                  .map((drug) => drug.cost)
                  .reduce((acc, curr) => acc + curr, 0)}`}
              </span> */}
            </div>
            <Button
              variant="outlined"
              rounded="full"
              disabled={disabledClaim}
              onClick={handleClaimFreeDrug}
            >
              {claimButtonText()}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimFreeDrug;
